module.exports = __webpack_public_path__ + "img/address.ecca5e22.jpg";